import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import classes from "./GuestOfHonorWorks.module.scss"

type Work = {
  src: string
  title: string
}

const GuestOfHonorWorks = () => {
  const { i18n } = useTranslation()
  let works: Work[] = []

  switch (i18n.language) {
    case "ja":
      works = [
        {
          src: "/img/guestOfHonor/JMF23_GoH_Mounting.jpg",
          title: "▲『マウンティング』",
        },
        {
          src: "/img/guestOfHonor/JMF23_GoH_bitter.jpg",
          title: "▲『bitter』",
        },
      ]
      break
    case "en":
      works = [
        {
          src: "/img/guestOfHonor/JMF23_GoH_Mounting.jpg",
          title: "▲“condescending”",
        },
        { src: "/img/guestOfHonor/JMF23_GoH_bitter.jpg", title: "▲“bitter”" },
      ]
  }

  return (
    <div className={classes.container}>
      {works.map((work, index) => {
        return (
          <div className={classes.work} key={index}>
            <div>
              <img src={work.src} alt={work.title} />
              <p>{work.title}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default GuestOfHonorWorks
